import { createFileRoute } from '@tanstack/react-router';

import { NotFoundView } from 'views/NotFoundView';

export const Route = createFileRoute('/404')({
  component: NotFoundView,
});
